import { Skeleton, Stack, Box, useTheme } from "@mui/material";

interface ActivityDetailsSkeletonProps {
  isInitialLoad: boolean;
}

const ActivityDetailsSkeleton = ({
  isInitialLoad,
}: ActivityDetailsSkeletonProps) => {
  const theme = useTheme();

  return (
    <Box className="activity-item">
      <Stack
        direction="row"
        spacing={theme.nawy.spacing.md}
        sx={{ padding: theme.nawy.spacing.sm }}
      >
        {/* Timeline dot with conditional connector */}
        <Stack
          alignItems="center"
          position="relative"
          marginTop={theme.nawy.spacing.sm}
        >
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
              bgcolor: theme.nawy.colors.semantic.layer.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: theme.nawy.colors.semantic.layer.primary,
              zIndex: 2,
              ...(isInitialLoad
                ? {
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: theme.nawy.spacing.xl,
                      width: "1px",
                      height: "100%",
                      backgroundColor:
                        theme.nawy.colors.semantic.border.secondary,
                      zIndex: 1,
                      left: "50%",
                      transform: "translateX(-50%)",
                    },
                    ".activity-item:last-of-type &::before": {
                      display: "none",
                    },
                  }
                : {
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: theme.nawy.spacing.xl,
                      width: "1px",
                      height: "100%",
                      backgroundColor:
                        theme.nawy.colors.semantic.border.secondary,
                      zIndex: 1,
                      left: "50%",
                      transform: "translateX(-50%)",
                    },
                    ".activity-item:last-of-type &::after": {
                      display: "none",
                    },
                  }),
            }}
          >
            <Skeleton variant="circular" width={16} height={16} />
          </Box>
        </Stack>

        {/* Content skeleton */}
        <Stack
          direction="column"
          spacing={theme.nawy.spacing.xs}
          bgcolor={theme.nawy.colors.semantic.layer.primary}
          borderRadius={theme.nawy.radius.lg}
          padding={theme.nawy.spacing.md}
          flex="1 0 0"
        >
          <Skeleton variant="rectangular" width="60%" height={18} />
          <Skeleton variant="rectangular" width="40%" height={16} />
          <Skeleton variant="rectangular" width="30%" height={16} />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={50}
            sx={{ borderRadius: theme.nawy.radius.md }}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default ActivityDetailsSkeleton;
